<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="typeForm" label-width="auto" label-position="right">
      <el-form-item label="分类名称：">
        <el-input v-model="typeForm.name" placeholder="请输入分类名称" />
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="typeForm.orderNum" placeholder="请输入数值" />
      </el-form-item>
<!--      <el-form-item label="">-->
<!--        <el-checkbox v-model="limitState">是否标记为需要客户回访</el-checkbox>-->
<!--      </el-form-item>-->
    </el-form>
<!--    {{preId}}-->
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateCommodityType } from "@/api/url";
import { phoneReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      typeForm: this.value.typeForm,
      idx: this.value.ids,
      preId: this.value.preId,
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.idx)
      if(!this.typeForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入分类名称',
          type: 'warning'
        });
        return false
      }
      if(!this.typeForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入排序数值',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.typeForm.id:0;
      param['preId'] = this.preId;
      param['name'] = this.typeForm.name;
      param['orderNum'] = this.typeForm.orderNum;
      postFormData(addOrUpdateCommodityType, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
